import React, { useState } from "react";
import styles from "./style.module.scss";
import RangeDatePicker from "shared/components/rangeDatePicker";
import DoughnutChart from "shared/components/doughnutChart";

function EarningStats() {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());

  const chartData = {
    labels: ["Earning from Plans", "Earning from Top ups"],
    values: [12, 19],
  };
  return (
    <div className={styles.mainContainer}>
      <div className={styles.upperContainer}>
        <div className={styles.upperHeadingContainer}>
          <div style={{ display: "flex", flexDirection: "column", gap: "9px" }}>
            <label className={styles.upperContainerHeading}>
              Total Earning
            </label>
            <label className={styles.totalEarningHeading}>578,300</label>
          </div>

          <div style={{ display: "flex", alignItems: "center" }}>
            <RangeDatePicker
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              labelStyle={styles.dateLabel}
            />
          </div>
        </div>
        <div>
          <label className={styles.subHeading}>
            Earning from coins & membership plans
          </label>
        </div>
      </div>

      <div
        style={{
          height: "1.43px",
          width: "100%",
          background: "#ECECEC",
        }}
      />
      <div className={styles.lowerContainer}>
        <div className={styles.graphContainer}>
          <div className={styles.graphHeadingContainer}>
            <label className={styles.graphHeading}>Coins Sold</label>
            <label className={styles.graphValue}>647,900</label>
          </div>
          <DoughnutChart data={chartData} canvasStyle={styles.canvas} />
        </div>
        <div className={styles.tagContainer}>
          <div className={styles.tabContainer}>
            <div className={styles.tabHeading}>Earning From Plans</div>
            <div className={styles.tabValue}>
              <span
                className={styles.colorIndicator}
                style={{ backgroundColor: "#EF437B" }}
              />
              Rs 235,600
            </div>
          </div>
          <div className={styles.tabContainer}>
            <div className={styles.tabHeading}>Earning From Topup</div>
            <div className={styles.tabValue}>
              <span
                className={styles.colorIndicator}
                style={{ backgroundColor: "#9A469B" }}
              />
              Rs 342,700
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EarningStats;
